import { useSelector } from "react-redux";
import { tokenSelector } from '@podcasts/store/user';
import { get } from 'lodash';

export const useIsAuthenticated = () => {
    const user = useSelector(state => get(state,'user.user'));
    const token = user?.token;
    const issued_at = user?.issued_at;
    const expires_in = user?.expires_in;
    const now = Date.now() / 1000;
    return !!token && now < issued_at + expires_in;
}
